import type { Opportunity } from "@entities";
import type { HyperTableDef } from "@shared/frontend/hyper-table/types";
import { useCallback, useState } from "react";

type Options = {
  hyperTable: HyperTableDef<Opportunity>;
  defaultTitle?: string;
};

export function useCommunicationRecordsDialog({
  hyperTable,
  defaultTitle = "משימה",
}: Options) {
  const [selectedOpportunity, setSelectedOpportunity] =
    useState<Opportunity | null>(null);

  const openCommunicationRecords = useCallback((opportunity: Opportunity) => {
    setSelectedOpportunity(opportunity);
  }, []);

  const closeCommunicationRecords = useCallback(() => {
    setSelectedOpportunity(null);
  }, []);

  const refreshTable = useCallback(() => {
    void hyperTable.context?.current?.refetch("invalidate");
  }, [hyperTable]);

  return {
    openCommunicationRecords,
    communicationRecordsDialogProps: {
      open: !!selectedOpportunity,
      onClose: closeCommunicationRecords,
      title: selectedOpportunity?.title || defaultTitle,
      opportunityId: selectedOpportunity?.id,
      type: "opportunity" as const,
      onSave: refreshTable,
    },
  };
}
